import type { InjectionKey } from 'vue';
import type { IGroupProvide } from '@components/composable';

export const CdsTabsSymbol: InjectionKey<IGroupProvide> = Symbol('cds:tabs');
